export default __webpack_public_path__ + "static/media/BM.413b03f1.png";